// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Y0lT","col":"styles_col__2ovPs","actions":"styles_actions__2b1Je","conflict":"styles_conflict__34EfG"};